import { Component } from '@angular/core';

import { DashboardStore, FlowInfo, jobStages } from '../dashboardv2.store';

@Component({
  selector: 'app-pipeline',
  templateUrl: './pipeline.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './pipeline.component.scss',
  ],
})
export class PipelineComponent {

  pipeline$ = this.dashboardStore.pipelineViewModel$;

  constructor(
    private readonly dashboardStore: DashboardStore,
  ) {}

  handlePipelineClick(flowInfo: FlowInfo | null) {
    this.setExpandedFlows(flowInfo);
    this.setJobType(flowInfo);
  }

  setExpandedFlows(flowInfo: FlowInfo | null) {

    // If user clicks outside the chart, collapse any expanded flows
    if (flowInfo === null) {
      this.dashboardStore.setExpandedFlows([]);
      return;
    }

    const { selectedJobType } = flowInfo;

    // If user clicks a non-expandable part of the chart, collapse any expanded flows
    if (!selectedJobType.status) {
      this.dashboardStore.setExpandedFlows([]);
      return;
    }

    // Otherwise, expand the part of the chart the user clicked
    this.dashboardStore.setExpandedFlows([{
      jobStage: selectedJobType.jobStage,
      status: selectedJobType.status,
    }]);
  }

  setJobType(flowInfo: FlowInfo | null) {

    // If user clicks outside the chart, do nothing
    if (flowInfo === null) {
      return;
    }

    const { selectedJobType } = flowInfo;

    // If user clicks inside the chart, populate the preview with the jobs in question
    this.dashboardStore.setJobStage(selectedJobType.jobStage);
    this.dashboardStore.setStatus(selectedJobType.status);
    this.dashboardStore.setJobClosureReason(selectedJobType.jobClosureReason);
    this.dashboardStore.setAttentionExplanation(selectedJobType.attentionExplanation);

    if (selectedJobType.source) {
      this.dashboardStore.setSource(selectedJobType.source);
    }

    if (selectedJobType.jobOrigin) {
      this.dashboardStore.setJobOrigin(selectedJobType.jobOrigin);
    }

    if (selectedJobType.estimateMethod) {
      this.dashboardStore.setEstimateMethod(selectedJobType.estimateMethod);
    }

    if (selectedJobType.estimator) {
      this.dashboardStore.setEstimator(selectedJobType.estimator);
    }

    if (selectedJobType.salesAgent) {
      this.dashboardStore.setSalesAgent(selectedJobType.salesAgent);
    }

    if (selectedJobType.utmSource) {
      this.dashboardStore.setUtmSource(selectedJobType.utmSource);
    }

    if (selectedJobType.utmTerm) {
      this.dashboardStore.setUtmTerm(selectedJobType.utmTerm);
    }

    if (selectedJobType.utmMedium) {
      this.dashboardStore.setUtmMedium(selectedJobType.utmMedium);
    }

    if (selectedJobType.utmCampaign) {
      this.dashboardStore.setUtmCampaign(selectedJobType.utmCampaign);
    }

    if (selectedJobType.utmContent) {
      this.dashboardStore.setUtmContent(selectedJobType.utmContent);
    }
  }

  isJobStage(stage: string): stage is typeof jobStages[number] {
    return jobStages.includes(stage as typeof jobStages[number]);
  }
}
